import { render } from "./CommentsListItem.vue?vue&type=template&id=0fe9fc08"
import script from "./CommentsListItem.vue?vue&type=script&lang=js"
export * from "./CommentsListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__